import { render, staticRenderFns } from "./UserInsights.vue?vue&type=template&id=90a6bfbc&scoped=true&"
import script from "./UserInsights.vue?vue&type=script&lang=js&"
export * from "./UserInsights.vue?vue&type=script&lang=js&"
import style0 from "./UserInsights.vue?vue&type=style&index=0&id=90a6bfbc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a6bfbc",
  null
  
)

export default component.exports